<template>
  <div class="my">
    <!-- 头部背景 -->
    <div class="home-wrapper"></div>
    <div class="user">
      <div class="left">
        <img src="@/assets/img/tabs/5.png" class="user-logo"/>
        <i class="user-text">我的</i>
      </div>
      <div class="right" @click="jumpcuAccountInfo">
        <img src="@/assets/img/my/edit.png" class="user-logo"/>
        <i class="user-text">登录/退出</i>
      </div>
    </div>
    <div class="user-msg" @click.stop="jumpSliding">
      <div class="left">
        <img src="@/assets/img/my/user-logo.png" class="user-img" v-if="userinfo.avatar == null"/>
        <img :src="userinfo.avatar" class="user-img" v-else/>
        <div class="user-content">
          <div class="user-name">
            {{ userinfo.store.name || '暂无' }}
            <i class="user-icon">&nbsp;</i>
          </div>
          <div class="user-reputation">
            <i>信誉:</i>
            <i class="level">{{ store.honestyName }}</i>
          </div>
        </div>
      </div>
      <div class="user-card">
        <img src="@/assets/img/my/card.png" class="card-img" alt/>
        名片
      </div>
    </div>
    <!-- <div>{{text}}</div> -->
    <div class="content-box">
      <div class="user-body">
        <div class="box">
          <p class="box-content" @click="downproducts">
            <img src="@/assets/img/my/downloads.png" alt class="box-img"/>
            <i class="box-text">下载离线包</i>
          </p>

          <p class="box-content" @click="jumpagreement">
            <img src="@/assets/img/my/agreement.png" alt class="box-img"/>
            <i class="box-text">协议</i>
          </p>
          <p class="box-content" @click="jumpservice">
            <img src="@/assets/img/my/service.png" alt class="box-img"/>
            <i class="box-text">已购服务</i>
          </p>
          <p class="box-content" @click="junpScan">
            <img src="@/assets/img/my/Scan.png" alt class="box-img"/>
            <i class="box-text">扫一扫</i>
          </p>
        </div>
        <div class="box">
          <p class="box-content" @click="jumpResidence">
            <img src="@/assets/img/my/address.png" alt class="box-img"/>
            <i class="box-text">地址管理</i>
          </p>
          <p class="box-content" @click="jumpAnnouncement">
            <img src="@/assets/img/my/agreement.png" alt class="box-img"/>
            <i class="box-text">公告管理</i>
          </p>
          <p class="box-content" @click="jumpGroup">
            <img src="@/assets/img/my/people.png" alt class="box-img"/>
            <i class="box-text">展台群</i>
          </p>
          <p class="box-content" @click="jumpNotepad">
            <img src="@/assets/img/my/Notepad.png" alt class="box-img"/>
            <i class="box-text">记事本</i>
          </p>
        </div>
        <div class="box">
          <!--    <p class="box-content" @click="jumpLottery">
            <img src="@/assets/img/my/agreement.png" alt class="box-img" />
            <i class="box-text">抽奖</i>
          </p> -->
          <!--  <p class="box-content" @click="jumpActivityManage">
            <img src="@/assets/img/my/agreement.png" alt class="box-img" />
            <i class="box-text">撞宝设置</i>
          </p> -->

          <p class="box-content" @click="uploadproducts">
            <img style="transform: rotate(180deg)" src="@/assets/img/my/downloads.png" alt class="box-img"/>
            <i class="box-text">上传离线包</i>
          </p>

          <!-- <p class="box-content" @click="jumpScan">
            <img src="@/assets/img/tabs/2.png" alt class="box-img" />
            <i class="box-text">谈宝</i>
          </p> -->
          <p class="box-content" @click="jumpLottery">
            <img src="@/assets/img/detail/lottery_icons.png" alt class="box-img"/>
            <i class="box-text">撞宝</i>
          </p>
          <p class="box-content" @click="jumpcustomer">
            <img src="@/assets/img/my/customer.png" alt class="box-img"/>
            <i class="box-text">客服</i>
          </p>
          <!-- <p class="box-content" @click="jumpcustomer2">
            <img src="@/assets/img/my/customer.png" alt class="box-img" />
            <i class="box-text">nfc读取</i>
          </p> -->
          <p class="box-content" @click="jumpUser">
            <img src="@/assets/img/my/agreement.png" alt class="box-img"/>
            <i class="box-text">名片设置</i>
          </p>
        </div>
        <div class="box">
          <p class="box-content" @click="jumpcuAddressBook">
            <img src="@/assets/img/my/agreement.png" alt class="box-img"/>
            <i class="box-text">缴费寄存</i>
          </p>

          <p class="box-content" @click="writeToNfc()">
            <img src="@/assets/img/my/code.png" alt class="box-img"/>
            <i class="box-text">写入芯片</i>
          </p>

          <p class="box-content" @click="jumpExhibition">
            <img src="@/assets/img/my/Notepad.png" alt class="box-img"/>
            <i class="box-text">展品管理</i>
          </p>
        </div>


      </div>
      <div class="user-foot">
        <div class="content" @click="jumpAdvertisement">
          <img src="@/assets/img/my/ad.png" alt class="content-img"/>
          <i class="content-text">广告</i>
        </div>
        <div class="content" @click="jumpExhibition">
          <img src="@/assets/img/my/Exhibition.png" alt class="content-img"/>
          <i class="content-text">展品管理</i>
        </div>
        <div class="content" @click="jumpSupplement">
          <img src="@/assets/img/my/add.png" alt class="content-img"/>
          <i class="content-text">补货</i>
        </div>
        <div class="content" @click="jumpartist">
          <img src="@/assets/img/my/ui.png" alt class="content-img"/>
          <i class="content-text">美工</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../utils/api'
import {aGet, aPost} from '../../utils/request'
import $ from 'jquery'
import {NavBar} from 'vant'
import {mapActions} from 'vuex'
import nfc from '../../utils/nfc.js'

export default {
  name: 'my',
  components: {},
  data() {
    return {
      id: JSON.parse(localStorage.getItem('id')),
      // 权限列表
      permissionsList: [],
      storeId: 0,
      powerStatus: undefined,
      userinfo: {},
      store: {},
      scan: null,
      codeUrl: ''
    }
  },
  methods: {
    // 展厅
    async jumpExhibition() {
      let obj = this.permissionsList.filter((item) => item.powerName == '展厅')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      console.log(123)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        console.log('111')
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        console.log('2222')
        this.$router.push({
          path: '/Exhibition'
        })
      }
      // },300)
    },

    // 写入nfc 24.8.14改写
    writeToNfc() {
      this.checkPermissions2()
        .then((res) => {
          console.log('checkPermissions2 theFlag:', this.theFlag)
          if (this.theFlag === true) {
            console.log('有权限,继续写入。writeToNfc...')
            //写一条记录,当前没有方法,暂时注释,待后续完善 24.8.14
            // aPost(api.upChipCodeTime, { productId: id }).then((res) => {
            //   console.log('aPost upChipCodeTime res:',res)

            // })

            var randomCode = Math.floor(1 + Math.random() * 100000000);
            //写入芯片
            var url3 = "https://www.eforall.cn/ttsH5/#/salesDetails?id=" + id + '&chipCode=' + randomCode;
            var url4 = "tatashi:///salesDetails?id=" + id;
            // nfc.inputChanage(url);
            //在nfc中处理了,此处不用提示
            // nfc.nfcRunning()
            // const res = nfc.writeData(url4 + "|"+url3)
            const res = nfc.writeData(url3)
            this.getLocations();
            console.log('writeToNfc res:', res)    //是nfcID
            if (res === 'ok') {
              this.$router.push('/')
            }

          } else {
            this.$toast('您暂无此权限,请先购买权限配置！')
            console.log('您暂无此权限,请先购买权限配置！')
            return
          }
        })
        .catch((err) => {
          this.$toast('程序错误,请重试')
          console.log('checkPermissions2 catch 报错:' + err.result.message)
        })
    },
    getLocations() {
      console.log(navigator.geolocation)
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPositions)
      } else {
        this.did = '该浏览器不支持获取地理位置。'
      }
    },
    showPositions(position) {
      console.log("positionposition8" + JSON.stringify(position))
      var latitude = position.coords.latitude
      var longitude = position.coords.longitude
      this.did = '纬度: ' + latitude + '<br>经度: ' + longitude
      this.latitude = latitude
      this.longitude = longitude
      this.getBaiduMapPoints(latitude, longitude)
    },
    getBaiduMapPoints(latitudes, longitudes) {
      this.$jsonp(`https://api.map.baidu.com/reverse_geocoding/v3/?ak=bs33FsZE1aGasRoS5Neq9qashphsybre&output=json&coordtype=wgs84ll
         &location=${latitudes},${longitudes}`)
        .then((res) => {
          // 得到我们想要的内容

          let parma = {
            userId: localStorage.getItem('id'),
            formattedAddress: res.result.formatted_address,
            longitude: res.result.location.lng,
            latitude: res.result.location.lat,
            country: res.result.addressComponent.country,
            province: res.result.addressComponent.province,
            city: res.result.addressComponent.city,
            district: res.result.addressComponent.district,
            street: res.result.addressComponent.street,
            chipUid: this.$store.state.lastChipUid
          }
          aPost(api.saveUserAddressLocaltionList, parma).then((res) => {
            console.log('checkOwner result7:', res.data.result)
            // this.isOwner = res.data.result
          })


          // this.latitude = res.result.location.lat
          // this.longitude = res.result.location.lng
          // this.center.lat = res.result.location.lat
          // this.center.lng = res.result.location.lng
        })
        .catch((err) => {
          console.log('请求百度接口报错:' + err.result.message)
        })
    },
    //改写 24.8.14
    async checkPermissions2() {
      let flag = false
      let parma = {
        storeId: localStorage.getItem('storeId'),
      }
      await aGet(api.getMyStorePermissionsList, parma).then((res) => {
        console.log('我的店铺权限:', res.data)
        this.permissionsList = res.data.data
        console.log("permissionsList:", this.permissionsList)
        let obj = this.permissionsList.filter((item) => item.powerName == '写入芯片')
        console.log("jumpDetail obj:", obj.length)

        this.powerStatus = obj.length > 0 ? true : false;
        console.log("jumpDetail powerStatus:", this.powerStatus)

        if (this.powerStatus != undefined) {
          if (this.powerStatus == false) {
            this.$toast('您暂无此权限,请先购买权限配置！')
            setTimeout(() => {
              this.$router.push({
                path: '/buyservice'
              })
            }, 300)
          } else {
            let flag = true
            this.theFlag = true

          }
        }

      })
    },
    ...mapActions(['setStoreId']),
    // 协议
    downproducts() {
      this.$router.push({
        path: '/downproducts'
      })
    },
    uploadproducts() {
      this.$router.push({
        path: '/upproducts'
      })
    },
    jumpSliding() {
      // console.log(11);
      this.$router.replace({
        path: '/mysliding'
      })
    },
    // 已购服务列表
    jumpservice() {
      this.$router.push({
        path: '/purchased'
      })
    },
    //扫一扫
    junpScan() {
      this.$router.push({
        path: '/scanformy'
      })
    },
    // 协议
    jumpagreement() {
      this.$router.push({
        path: '/agreement'
      })
    },
    // 地址
    jumpResidence() {
      this.$router.push({
        path: '/Residence'
      })
    },
    // 公告
    jumpAnnouncement() {
      this.$router.push({
        path: '/Announcement?storeId=' + this.storeId
      })
    },
    // 抽奖
    jumpLottery() {
      this.$router.push({
        path: '/Lottery?storeId=' + this.storeId
      })
    },
    // 活动管理
    jumpActivityManage() {
      this.$router.push({
        path: '/activitymanage?storeId=' + this.storeId
      })
    },
    // 谈宝
    jumpScan() {
      this.$router.push({
        path: '/scan'
      })
    },
    // 展台群
    async jumpGroup() {
      let obj = this.permissionsList.filter((item) => item.powerName == '展台群')
      console.log(obj)
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        // if (this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/Group'
          // query: {
          //   // powersId: obj[0].id,
          //   storeId: this.storeId
          // }
        })
      }
      // }
      // },300)
    },
    // 记事本
    async jumpNotepad() {
      let obj = this.permissionsList.filter((item) => item.powerName == '记事本')
      console.log('xxx', obj)
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      console.log('aaaa', this.powerStatus)
      // setTimeout( () => {
      if (!this.powerStatus) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        console.log('mei')
        // if (this.powerStatus == false) {
        this.$router.push({
          path: '/buyservice'
        })
      } else {
        console.log('you')
        this.$router.push({
          path: '/Notepad'
        })
      }
      // }
      // },300)
    },
    // 客服
    jumpcustomer() {
      this.$router.push({
        path: '/customer'
      })
    },
    // nfc
    jumpcustomer2() {
      nfc.readData()
    },
    // 账号信息
    jumpcuAccountInfo() {
      this.$router.push({
        path: '/accountinfo'
      })
    },
    // 通讯录
    jumpcuAddressBook() {
      this.$router.push({
        path: '/addressbook'
      })
    },
    // 广告
    async jumpAdvertisement() {
      let obj = this.permissionsList.filter((item) => item.powerName == '广告')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        // if (this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/Advertisement'
        })
      }
      // }
      // },300)
    },
    // 美工
    async jumpartist() {
      let obj = this.permissionsList.filter((item) => item.powerName == '美工')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/artist'
        })
      }
      // },300)
    },
    // 我的
    jumpUser() {
      this.$router.push({
        path: '/Userinfo'
      })
    },
    // 补货
    async jumpSupplement() {
      let obj = this.permissionsList.filter((item) => item.powerName == '补货')
      console.log('obj', obj)
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      console.log(11)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/Supplement'
        })
      }
      // },300)
    },
    // 获取我的信息
    userMessage() {
      let parma = {
        id: this.id
      }
      aPost(api.getUserInfo, parma).then((res) => {
        console.log('我的信息', res)
        this.storeId = res.data.data.store.id
        localStorage.setItem('storeId', this.storeId)
        console.log('this.storeId', this.storeId)
        this.store = res.data.data.store
        if (this.store.name == null) {
          this.store.name = '';
        }
        localStorage.setItem('type', this.store.storeIdentity)
        this.userinfo = res.data.data
        console.log('--------------', this.userinfo)
        console.log(this.store)
      })
    },
    // 获取全部店铺权限
    getAllStorePermissionsList() {
      aGet(api.getAllStorePermissionsList).then((res) => {
        console.log('全部店铺权限', res)
        this.permissionsList = res.data.data
        console.log('xxxx', this.permissionsList)
      })
    },
    // 查询用户是否购买功能权限
    async getUserWhetherPurchaseStorePermissions(id) {
      // return new Promise(reslove => {
      let parma = {
        storeId: this.storeId,
        powersId: id
      }
      console.log(parma)
      // let res = aGet(api.getUserWhetherPurchaseStorePermissions,parma)
      await aGet(api.getUserWhetherPurchaseStorePermissions, parma).then((res) => {
        this.powerStatus = res.data
        console.log('222', this.powerStatus)
      })

      // console.log('查询用户是否购买功能权限',res);

      // reslove(res.data)
      // })
    }
  },
  computed: {},
  created() {
    this.setStoreId(JSON.parse(localStorage.getItem('storeId')))
    //底部导航栏定位
    this.$store.state.bmTab = 5
    nfc.listenNFCStatus()
    nfc.readData()
  },
  mounted() {
    this.userMessage()
    this.getAllStorePermissionsList()
  },
  watch: {
    $route: function (to, from, next) {
      console.log('1132', to.meta.keepAlive, to)
    }
  },
  updated() {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/mixin';

.my {
  background: #f2f5f3;
  // min-height: 100%;
  // min-width: 100%;
  // max-height: 100%;
  // height: 90%;
  height: 100vh;
  padding-bottom: 60px;

  .home-wrapper {
    width: 100%;
    height: 20%;
    background: url('../../assets/img/home/bc.png') center bottom no-repeat;
    background-size: cover;
    position: fixed;
    top: 50px;
    left: 0;
  }

  .user {
    position: relative;
    z-index: 1;
    display: inline-flex;
    // margin-left: 32px;
    // margin-top: 30px;
    width: 100%;
    justify-content: space-between;
    padding: 30px;
    padding-bottom: 0;

    .left {
      display: inline-flex;

      .user-logo {
        width: 40px;
        height: 40px;
      }

      .user-text {
        // width: 68px;
        // height: 34px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        // line-height: 46px;
        color: #000000;
        opacity: 1;
        margin-left: 16px;
        margin-top: -4px;
      }
    }

    .right {
      display: inline-flex;
      align-items: center;

      .user-logo {
        width: 40px;
        height: 40px;
      }

      .user-text {
        // width: 68px;
        // height: 34px;
        // height: 28px;
        line-height: 45px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        opacity: 1;
        margin-left: 16px;
        margin-top: 0px;
      }
    }
  }

  .user-msg {
    padding: 0 32px;
    width: 686px;
    height: 160px;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    margin-top: 20px;
    margin-left: 32px;
    display: inline-flex;
    justify-content: space-between;

    .left {
      display: inline-flex;
      // padding-right: 40px;
    }

    .user-img {
      width: 96px;
      height: 96px;
      margin-top: 32px;
      // margin-left: 24px;
      border-radius: 50%;
    }

    .user-content {
      margin-left: 32px;
      margin-top: 38px;

      .user-name {
        display: inline-flex;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 51px;
        color: #222222;
      }

      .user-reputation {
        .level {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #222222;
        }
      }
    }

    .user-card {
      width: 150px;
      height: 72px;
      background: #f2f5f3;
      opacity: 1;
      border-radius: 36px;
      display: inline-flex;
      margin-top: 37px;
      // margin-left: 140px;
      justify-content: center;
      align-items: center;

      .card-img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
  }

  .content-box {
    // margin-top: 38%;
    // height: 70%;
    // position: absolute;
    // bottom: 70px;
    // padding-bottom: 150px;
    margin-top: 30px;
  }

  .user-body {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    // margin-left: 37px;
    // width: 686px;
    margin: 0 30px;
    height: auto;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px;
    position: relative;
    z-index: 1;

    .box {
      // display: inline-flex;
      // width: 100%;
      // justify-content: left;
      display: flex;
      justify-content: space-between;
      margin: 0 30px;

      .box-content {
        // width: 172px;
        // height: 172px;
        width: 160px;
        height: 160px;
        opacity: 1;
        display: flex;
        // justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 24px;

        .box-img {
          width: 60px;
          height: 60px;
        }

        .box-text {
          margin-top: 16px;
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #222222;
        }
      }
    }
  }

  .user-foot {
    width: 686px;
    height: 163px;
    background: #fff;
    margin-left: 32px;
    margin-top: 24px;
    margin-bottom: 50px;
    display: inline-flex;
    border-radius: 20px;

    .content {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .content-img {
        width: 54px;
        height: 54px;
      }

      .content-text {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        margin-top: 15px;
        color: #222222;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/my.vue